module.exports = __webpack_public_path__ + "static/img/zhutu挖掘机.b07a8f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/zhutu挖掘机.png
// module id = Ne2S
// module chunks = 0